import React from 'react';

const Vue_v_for = () => {
  return (
    <div>
      <h1>Vue_v_for Component</h1>
      <p>This is the Vue_v_for tutorial page.</p>
    </div>
  );
}

export default Vue_v_for;
